import React from "react";

type DividerProps = {
  color?: string;
  width?: string;
  className?: string;
};

const Divider: React.FunctionComponent<DividerProps> = ({
  color = "#fbbb21",
  width = "8.4375rem",
  className = "",
}): React.ReactElement => {
  const styles = {
    width: `${width}`,
    backgroundColor: color,
  };
  return <div className={`divider ${className}`} style={styles} />;
};

export default Divider;
